import { useCallback, useMemo } from 'react';
import { HighwayArea } from '@thive/fddm-types';

import { SelectInput } from '@common/components/inputs';
import { FddmServiceFactory } from '@/modules/canvas/services/Floorplan/FddmServiceFactory';

const OPTIONS: { label: string; value: HighwayArea['connectNeighbors'] }[] = [
  { label: 'Curved', value: 'MAP_NEIGHBORS_WITHOUT_PIVOTS_FORWARD_ONLY' },
  { label: 'Pivot', value: 'MAP_NEIGHBORS_WITH_PIVOTS_FORWARD_ONLY' },
];

type Props = {
  selectedHighwayArea: HighwayArea;
};

export function HighwayConnectNeighbors({ selectedHighwayArea }: Props) {
  const fddmSvc = useMemo(() => FddmServiceFactory.getInstance().createFddmService(), []);

  const onChange = useCallback(
    (newValue: HighwayArea['connectNeighbors']) => {
      fddmSvc.updateArea({ ...selectedHighwayArea, connectNeighbors: newValue });
      fddmSvc.setPreference('highwayArea.connectNeighbors', newValue);
    },
    [selectedHighwayArea, fddmSvc],
  );

  return (
    <SelectInput
      options={OPTIONS}
      onChange={onChange}
      value={selectedHighwayArea.connectNeighbors}
    />
  );
}
